// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"710":"8a4613b1","981":"0981b69c","996":"7f096036"}[chunkId] + ".css";
};